import React, { Component } from "react";
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class ResumeItem extends Component {

    generateLinks(jobLink, index) {
        return (
            <li className="link"
                key={index}>
                    <span><FontAwesomeIcon icon="fa-solid fa-arrow-pointer"/></span>
                    <a 
                        href={jobLink["url"]}
                        rel="noreferrer"
                        target="_blank"
                    >
                            {jobLink["text"]}
                    </a>
            </li>
        );
    }

    generateHighlights(highlight, index) {
        return (
            <li key={"highlight" + index}>{highlight}</li>
        );
    }
    generateJobDetails(jobDetail, index) {
        return (
            <p
            className="job-detail" 
            key={"jobDetail" + index}>{jobDetail}</p>
        );
    }
    render() {
        return (
            <div className={classNames("resume-item", this.props.company)}>
                <div className="resume-item-headline">
                        <div className="job-employer">
                            <span>{this.props.title1}</span>
                            <span>{this.props.title2}</span>
                            <span className="freelance">{this.props.freelance}</span>
                            {this.props.links ?
                                <ul className="links">
                                    {Array.from(this.props.links).map(this.generateLinks)}
                                </ul>

                                :

                                null
                            }
                        </div>
                        <div className="job-title-and-date">
                            <div className="job-title">
                                <FontAwesomeIcon icon="fa-solid fa-gears"/>{this.props.jobTitle}
                            </div>
                            <div className="job-date">
                                <FontAwesomeIcon icon="fa-regular fa-calendar-days"/>
                                {this.props.startDate} –<br/>
                                {this.props.endDate}
                            </div>
                        </div>
                    </div>
                    <ul className="job-highlights">
                        {Array.from(this.props.highlights).map(this.generateHighlights)}
                    </ul>
                    <div className="job-details">
                        {Array.from(this.props.jobDetails).map(this.generateJobDetails)}
                    </div>
                    <p className="job-detail">
                        <strong>Skills</strong>: {this.props.skills}
                    </p>
                    {this.props.featuredClients ? 
                        <p className="job-detail">
                            <strong>Featured Clients:</strong>: {this.props.featuredClients}
                        </p>

                        :

                        null
                    }
            </div>
        );
    }
}

export default ResumeItem;